import _debounce from 'lodash-es/throttle';
import touches from 'touches';

export class Swipe {
    constructor() {
        this.node = null;
        this.scrolling = false;

        this.x = 0;
        this.startX = 0;
        this.distance = 0;

        this.accelleration = 10;
        this.threshold = 10;

        this.onSwipeChanged = () => {};

        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);

        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        this.doTouchScroll = _debounce(this._doTouchScroll);
    }

    attach(node, { onSwipeChanged = null, acceleration, threshold }) {
        this.node = node;
        if (onSwipeChanged) {
            this.onSwipeChanged = onSwipeChanged;
        }

        if (acceleration) {
            this.acceleration = acceleration;
        }

        if (threshold) {
            this.threshold = threshold;
        }

        node.addEventListener('mousedown', this.onMouseDown);
        window.addEventListener('mouseup', this.onMouseUp);
        node.addEventListener('mousemove', this.onMouseMove);
        node.addEventListener('mouseleave', this.onMouseLeave);

        touches(this.node, {
            filtered: true,
            type: 'touch',
            preventSimulated: false,
        }).on('start', this.onTouchStart);

        touches(window, {
            target: this.node,
            filtered: true,
            type: 'touch',
            preventSimulated: false,
        })
            .on('move', this.onTouchMove)
            .on('end', this.onTouchEnd);

        return {
            destroy: () => {
                node.removeEventListener('mousedown', this.onMouseDown);
            },
        };
    }

    onMouseDown(e) {
        e.preventDefault();
        this.scrolling = true;
        this.x = e.screenX;
        this.startX = e.screenX;
    }

    onMouseMove(e) {
        if (this.scrolling) {
            e.preventDefault();
            this.doTouchScroll(e.screenX);
            this.x = e.screenX;
        }
    }

    onMouseUp(e) {
        if (this.scrolling) {
            e.preventDefault();
            this.doTouchScroll(e.screenX);
            this.x = 0;
            this.startX = 0;
        }
        this.scrolling = false;
    }

    onMouseLeave() {
        this.scrolling = false;
        this.x = 0;
        this.startX = null;
    }

    onTouchStart(e, [x]) {
        this.x = x;
        this.startX = x;
    }

    onTouchMove(e, [x]) {
        if (this.startX !== null && !this.scrolling) {
            const distance =
                x > this.startX ? x - this.startX : this.startX - x;
            if (distance > this.threshold) {
                this.scrolling = true;
            }
        }
        if (this.scrolling) {
            e.preventDefault();
            this.doTouchScroll(x);
            this.x = x;
        }
    }

    onTouchEnd(e, [x]) {
        if (this.scrolling) {
            const before = this.x;
            this.doTouchScroll(x, before);
        }
        this.scrolling = false;
        this.startX = null;
        this.x = 0;
    }

    _doTouchScroll(now, before = this.x) {
        const currentDistance = before - now;
        this.node.scrollLeft = this.node.scrollLeft + currentDistance * 10;
        this.onSwipeChanged({ scrollLeft: this.node.scrollLeft });
    }
}
